'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _constants = require('./constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChooserClassColor = function () {
    function ChooserClassColor() {
        (0, _classCallCheck3.default)(this, ChooserClassColor);

        this.themesClass = ['green-theme', 'blue-theme', 'orange-theme', 'red-theme', 'navy-theme', 'dark-green-theme', 'dark-theme'];
    }

    (0, _createClass3.default)(ChooserClassColor, [{
        key: 'chooseClass',
        value: function chooseClass(color) {
            if (__CLIENT__) {
                var doc = window.document.getElementsByTagName('body')[0];
                this.themesClass.forEach(function (item) {
                    doc.classList.remove(item);
                });
                switch (color) {
                    case _constants.GREEN:
                        doc.classList.add('green-theme');
                        break;
                    case _constants.BLUE:
                        doc.classList.add('blue-theme');
                        break;
                    case _constants.ORANGE:
                        doc.classList.add('orange-theme');
                        break;
                    case _constants.RED:
                        doc.classList.add('red-theme');
                        break;
                    case _constants.NAVY:
                        doc.classList.add('navy-theme');
                        break;
                    case _constants.DARK_THEME:
                        doc.classList.add('dark-theme');
                        break;
                }
            }
        }
    }]);
    return ChooserClassColor;
}();

exports.default = ChooserClassColor;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ColorChooser/ChooserClassColor.js
// module id = 1641
// module chunks = 0